import React from "react";
import { useMessageSource } from "react-message-source";
import CustomTypography from "../../typography";

import "./styles.scss";
import useProductSpecificProperties from "../useProductSpecificProperties";
import LoyaltyProgrammes from "../loyalty-programes";
import { Product } from "../../../../context/product-context/product";

const classNameBase = "scd-product-selection-benefits";

export const Benefit = ({
  label,
  iconTick,
  className,
}: {
  label: string;
  iconTick?: boolean;
  className?: string;
}): React.JSX.Element => {
  return (
    <>
      <li className={className}>
        <CustomTypography
          variant="body2"
          className={`${classNameBase}-item-label`}
        >
          {iconTick && <i className="icon-scd-product-checkmark" />}
          {label}
        </CustomTypography>
      </li>
    </>
  );
};

export default function ProductBenefits({
  selectedProduct,
}: {
  selectedProduct: Product;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  const { getProductCost } = useProductSpecificProperties();

  const productSpecificProps = getProductCost(selectedProduct?.productRef);

  const { firstYearCost, afterFirstYearCost } = productSpecificProps;

  return (
    <ul className={`${classNameBase}`}>
      <LoyaltyProgrammes selectedProduct={selectedProduct} />
      <Benefit
        className={`${classNameBase}-item`}
        iconTick
        label={getMessage(
          "ProductBenefits.packageCost-label",
          firstYearCost,
          afterFirstYearCost,
        )}
      />
    </ul>
  );
}
